import { Component, OnDestroy, OnInit } from '@angular/core';
import { config, AnnouncementService, MemberQuery, PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { TPFService } from 'src/app/model/tpf/tpf.service';
import { calculateAge, getKidType, KidTypeE, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';
import { Tags } from 'src/app/shared/utilities/tags';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit, OnDestroy {
  config = config;
  screenSize = ScreenType;
  memberInfo$: Observable<{ firstName: string; kidType: KidTypeT }>;
  populations = Populations;
  isKid: boolean;
  KidType = KidTypeE;
  shopURL: string;
  private _destroyed$ = new Subject<void>();
  tags = Tags;

  constructor(
    private announcementService: AnnouncementService,
    private memberQuery: MemberQuery,
    private populationQuery: PopulationQuery,
    private tpfService: TPFService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.memberInfo$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          const age = calculateAge(new Date(m.DOB));
          const kidType = getKidType(age);
          return { firstName: m.FirstName, kidType };
        }
        return { firstName: '', kidType: 'Other' };
      })
    );
    this.announcementService.fetchAnnouncements().toPromise();
    this.isKid = this.populationQuery.userInPopulation([this.populations.Kids]);
    this.shopLink();
  }

  launchShop(url: string) {
    this.tpfService.sso(1, url);
  }

  shopLink() {
    this.translate
      .stream('nav.shop.link.url')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        this.shopURL = data;
      });
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
